import React from 'react';
import useIsInsideApp from 'hooks/useIsInsideApp';
import { Row, Col, Hidden, Visible } from 'components/Grid';
import LoginButton from './components/LoginButton';
import LanguageSelect from './components/LanguageSelect';

import { Container, LogoContainer, Logo, Back } from './styles';
import * as webView from 'utils/webView';

const Top = () => {
  const isInsideApp = useIsInsideApp();

  return (
    <Container align="center" $isInsideApp={isInsideApp}>
      <Col>
        <Hidden xs>
          <Logo alt="logo" src="/assets/images/logo.svg" />
        </Hidden>
        <Visible xs>
          <LogoContainer>
            {isInsideApp ? (
              <>
                <Back onClick={webView.goBackToApp} />
                <Logo.app alt="logo" src="/assets/images/logo.svg" />
              </>
            ) : (
              <Logo.xs alt="logo" src="/assets/images/logo.svg" />
            )}
          </LogoContainer>
        </Visible>
      </Col>
      <Col>
        <Row justify="end">
          <LoginButton />
          <LanguageSelect />
        </Row>
      </Col>
    </Container>
  );
};

export default Top;
